// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0dab3459","404":"b58b33bb","498":"1d42603c"}[chunkId] + ".chunk.js";
};